import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { Router, ActivatedRoute } from '@angular/router';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';

@Component({
  selector: 'mail-confirm-component',
  templateUrl: '../sharedTemplates/mail-confirm.component.html',
})
export class MailConfirm implements OnInit, AfterViewInit {
  confirmkey = '';
  langId = '';
  mailConfirmMessage = '';
  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _router: Router,
    private route: ActivatedRoute,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService
  ) {}

  ngOnInit() {
    this.confirmkey = this.route.snapshot.queryParams['s'];
    this.langId = this.route.snapshot.queryParams['l'];

    /*    this.route.params.subscribe(params => {
      this.confirmkey = params['s'];
    });*/
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Mail_Confirm');
    this.mailConfirm();
  }

  mailConfirm() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.mailConfirm(this.confirmkey, this.langId).then(result => {
      if (result.code === 'error') {
        this.mailConfirmMessage = result.message;
      } else if (result.code === 'success') {
        const t_message = translator.transform(result.message, null);
        this.mailConfirmMessage = t_message;

        this._ApiService
          .signOut()
          .then(result => {
            this._UserHelper.userLogOut();
            this._router.navigate(['/home']);
          })
          .catch(err => console.log('mail-confrim', err));
      }
    });
  }
}
